// extracted by mini-css-extract-plugin
module.exports = {"messageStatus":"MessageStatus_messageStatus__1Pn9p"};